module.exports = __webpack_public_path__ + "img/whatsapp_icon.cc61a69a.svg";